import React from 'react';
import { StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { coaches } from '../data/coaches';
const chips = ['6 Volumes', '5 Bonuses', '300+ Pages', 'Levels 1–6', 'Every season phase'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print it and coach from it'];
export function Hero() {
  return <section className="w-full bg-navy-deep" data-id="element-99" data-mp="129h21r4ip6f0">
      <div className="max-w-6xl mx-auto px-5 pt-6 pb-16 sm:pt-10 sm:pb-20" data-id="element-100" data-mp="128607wumu8qj">
        <div className="grid items-center gap-10 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-101" data-mp="x9un9d91ji43">
          <div data-id="element-102" data-mp="sarvuvlzhael">
            <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-103" data-mp="sai16upzuf2k">
              The season-ready system for cheer coaches
            </p>
            <h1 className="mt-3 font-display font-bold uppercase text-white text-4xl leading-[.91] tracking-tight sm:text-6xl md:text-7xl" data-id="element-104" data-mp="nekqp51ew2xp">
              Your next cheer practice is{' '}
              <span className="text-gold" data-id="element-105" data-mp="384jtz17ihntz">already written.</span>
            </h1>
            <p className="mt-5 max-w-xl text-base sm:text-lg text-white/75" data-id="element-106" data-mp="3j928hxbf86zr">
              Cheer Coach Pro is a six-volume coaching system: 300+ pages of
              written practices, stunt progressions, tryout scripts, sideline
              material and season admin. Not blank pages to fill in — the
              practice itself, ready to run.
            </p>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-107" data-mp="30hre366hlc34">
              {chips.map(chip => <li key={chip} className="rounded-full border border-navy-line px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-white/70" data-id="element-108" data-mp="358zq89z7bbjz">
                  {chip}
                </li>)}
            </ul>
          </div>

          <img src="https://cdn.magicpatterns.com/uploads/kA9rMGNVZjef4jRLAyfBcV/hf_20260917_201332_a3bfb0b8-157d-4b54-a2eb-451848ca04aa.png" alt="Cheer Coach Pro box set: six spiral-bound volumes fanned out above the system shown on desktop, tablet and phone" width={1200} height={886} className="w-full h-auto" data-id="element-109" data-mp="2hix2u768etrp" />
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-110" data-mp="ibgnkzh73tmc">
          <div className="w-full max-w-md" data-id="element-111" data-mp="i9vpizvo9sjq">
            <CtaButton data-id="element-112" data-mp="de6o0r03e1ks">Get Cheer Coach Pro</CtaButton>
          </div>
          <div className="mt-5 flex flex-col items-center gap-2.5 sm:flex-row sm:gap-4" data-id="element-113" data-mp="1b0njdqp9m53w">
            <ul className="flex -space-x-2.5" data-id="element-114" data-mp="161t3awiomunh">
              {coaches.map(coach => <li key={coach.name} data-id="element-115" data-mp="15zzv3csf82dd">
                  <img src={coach.avatar} alt={coach.name} width={40} height={40} loading="lazy" className="h-10 w-10 rounded-full border-2 border-navy-deep object-cover" data-id="element-116" data-mp="111ycsu2tk72y" />
                </li>)}
            </ul>
            <div className="text-center sm:text-left" data-id="element-117" data-mp="3htpzbveggqo1">
              <span className="flex justify-center gap-0.5 sm:justify-start" aria-label="Rated 4.9 out of 5" data-id="element-118" data-mp="1xam5wruslszg">
                {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-119" data-mp="268g1g0kqgilk" />)}
              </span>
              <p className="mt-1 text-xs text-white/65" data-id="element-120" data-mp="2fziz0segefg3">
                <span className="font-bold text-white" data-id="element-121" data-mp="2ky4352wttj9t">4.9/5</span> from 1,200+
                cheer coaches running this system
              </p>
            </div>
          </div>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-122" data-mp="2tzbokke8upmh">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-123" data-mp="unrbv0pwrruz">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-124" data-mp="zl11agdas3it" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}